import {
    Banner,
    Campaign,
    convertCampaignSourcesFromDto,
    convertRegionsFromDto,
    getAdEditOrCopyCampaignBatchActions,
    getBannerCreateBatchActions,
    getBannerEditBatchActions,
    getBannerIdFromMatch,
    getCampaignIdFromMatch,
} from 'utils/campaign';
import { CampaignFields } from 'utils/campaign/requirementUtils/types';
import { sortAreas, sortProfRoles } from 'utils/clickme';
import { CampaignProcess, CampaignSteps } from 'utils/constants/campaign';
import { BEProfRoles, hasProfRoles } from 'utils/profRoles';

import { ModelData } from '@hh.ru/magritte-ui';

import { Requirements } from 'app/routes';

import { PROF_ROLES, RegionBE, setErirClassificationCatalog, setProfRoles, setRegions } from 'store/autoReducers';
import { setIsAdvertisement } from 'store/models/createBanner';
import { setRequisitesFilled } from 'store/models/requisites';

// todo ситуация с неверным campaignId или bannerId
export const AdCopyPageRequirements: Requirements<{
    campaign: Campaign;
    banner: Banner;
    regions: RegionBE[];
    existRequisites: { existRequisites: boolean };
    [PROF_ROLES]: BEProfRoles;
    erirClassificationCatalog: ModelData[];
}> = {
    methods: ({ match }) => {
        const campaignId = getCampaignIdFromMatch(match) || '';
        const bannerId = getBannerIdFromMatch(match) || '';
        return {
            campaign: { url: `/api/v1/campaigns/${campaignId}`, cacheable: false },
            banner: { url: `/api/v1/banners/${bannerId}`, cacheable: false },
            regions: { url: '/api/v1/catalog/areas' },
            existRequisites: { url: '/api/v1/requisites/exist_requisites', cacheable: false },
            erirClassificationCatalog: { url: '/api/v1/catalog/erir/classification/tree' },
        };
    },
    isDataReady: ({ result }) => hasProfRoles(result),
    additionalMethods: () => ({
        [PROF_ROLES]: {
            url: `/api/v1/catalog/professionalCatalog`,
        },
    }),
    resolve: ({
        result: {
            campaign,
            banner,
            regions,
            existRequisites: { existRequisites },
            erirClassificationCatalog,
            ...professions
        },
    }) => {
        const campaignForCopy = {
            ...campaign,
            apiSources: convertCampaignSourcesFromDto(campaign.campaignSources),
            vacancyId: null,
            id: null,
            banner: {
                ...campaign[CampaignFields.Banner],
                classificationCodeId: null,
            },
        };

        const bannerForCopy = {
            ...banner,
            id: 0,
            vacancyId: null,
            url: '',
        };

        return [
            ...getBannerCreateBatchActions({
                campaign: campaignForCopy,
                campaignIdForBanner: '',
            }),
            ...getBannerEditBatchActions({ banner: bannerForCopy }),
            ...getAdEditOrCopyCampaignBatchActions({
                step: CampaignSteps.First,
                campaign: campaignForCopy,
                campaignProcess: CampaignProcess.Copy,
            }),
            setRegions(sortAreas(convertRegionsFromDto(regions))),
            setProfRoles(sortProfRoles(professions[PROF_ROLES].professionalCategories)),
            setRequisitesFilled(existRequisites),
            setErirClassificationCatalog(erirClassificationCatalog),
            ...(bannerForCopy.bannedAsAdvertisement ? [setIsAdvertisement(true)] : []),
        ];
    },
};
